import numeral from "numeral";

export default value =>
  value === null ? "" : numeral(value).format("$0,0[.]00");
